/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Saved_ToastInputs */

const en_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guide changes saved`)
};

const fr_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications du guide de style enregistrees`)
};

const de_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen am Styleguide gespeichert`)
};

const it_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche alla guida di stile salvate`)
};

const ru_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранены изменения в руководстве по стилю.`)
};

const es_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios en la guía de estilo guardados`)
};

const zh_cn2_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南更改已保存`)
};

const ja_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドの変更を保存しました`)
};

const hi_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड में किए गए बदलाव सहेज लिए गए हैं।`)
};

const pt_pt2_style_guide_manager_saved_toast = /** @type {(inputs: Style_Guide_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações no guia de estilo salvas`)
};

/**
* | output |
* | --- |
* | "Style guide changes saved" |
*
* @param {Style_Guide_Manager_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_saved_toast = /** @type {((inputs?: Style_Guide_Manager_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_saved_toast(inputs)
	if (locale === "de") return de_style_guide_manager_saved_toast(inputs)
	if (locale === "it") return it_style_guide_manager_saved_toast(inputs)
	if (locale === "ru") return ru_style_guide_manager_saved_toast(inputs)
	if (locale === "es") return es_style_guide_manager_saved_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_saved_toast(inputs)
	if (locale === "ja") return ja_style_guide_manager_saved_toast(inputs)
	if (locale === "hi") return hi_style_guide_manager_saved_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_saved_toast(inputs)
	return en_style_guide_manager_saved_toast(inputs)
});